module.exports = __webpack_public_path__ + "img/Stickers-examenbundel.3d73074.png";